// extracted by mini-css-extract-plugin
export default {"uk-private-company-top":"styles-module__uk-private-company-top___V1Tec"};